const URLS = {
  tutorial: "https://www.youtube.com/@chargebackio/videos",
  tutorialEnrollment: "https://www.youtube.com/watch?v=hklNsj3aXeQ",
  help: "https://help.chargeback.io/en/",
  helpEnrollment:
    "https://help.chargeback.io/en/articles/12782860-comparing-ethoca-rdr-cdrn-enrollments",
  helpIntegration: "https://help.chargeback.io/en/collections/16516793-setting-up-integrations",
  helpBilling: "https://help.chargeback.io/en/collections/16516790-setting-up-enrollments",
  helpTopUp: "https://help.chargeback.io/en/articles/12782877-what-is-balance-billing",
  support: null
}

export const QUICK_ITEMS = {
  helpCenter: {
    icon: "rescue_ring",
    title: "Visit help center",
    description: "Find guides and best practices for using Chargeback.",
    url: URLS.helpIntegration
  },
  helpConnectIntegration: {
    icon: "rescue_ring",
    title: "Visit help center",
    description: "Learn how to connect your integration here.",
    url: URLS.helpIntegration
  },
  helpEnrollment: {
    icon: "rescue_ring",
    title: "Visit help center",
    description: "Find guides and best practices for choosing the right enrollments.",
    url: URLS.helpEnrollment
  },
  helpBillingDescriptor: {
    icon: "rescue_ring",
    title: "Visit help center",
    description: "Learn how to find your billing descriptor(s).",
    url: URLS.helpBilling
  },
  helpBalanceBilling: {
    icon: "rescue_ring",
    title: "Visit help center",
    description: "Learn how balance billing works.",
    url: URLS.helpTopUp
  },
  helpGettingStarted: {
    icon: "rescue_ring",
    title: "Visit help center",
    description: "Find guides, troubleshooting steps, and best practices for using Chargeback.",
    url: URLS.help
  },
  contactSupport: {
    icon: "support_full",
    title: "Contact support",
    description: "Need help? Get live chat support.",
    url: URLS.support
  },
  watchIntegrationsTutorial: {
    icon: "play",
    title: "Watch tutorial",
    description: "Watch step-by-step tutorials to learn how integrations works.",
    url: URLS.tutorial,
    recommended: true
  },
  watchEnrollmentTutorial: {
    icon: "play",
    title: "Watch enrollment tutorial",
    description: "Watch tutorial to learn which enrollment you should choose.",
    url: URLS.tutorialEnrollment
  },
  watchGettingStartedTutorial: {
    icon: "play",
    title: "Watch tutorial",
    description: "Watch step-by-step tutorials to quickly learn how Chargeback works.",
    url: URLS.tutorial,
    recommended: true
  }
}

export const PRESETS = {
  HELP_AND_SUPPORT: ["helpCenter", "contactSupport"],
  SUPPORT_ONLY: ["contactSupport"]
}

export const QUICKLIST_BY_STEP = {
  "business-info": PRESETS.HELP_AND_SUPPORT,
  "payment-connect": ["watchIntegrationsTutorial", "helpConnectIntegration", "contactSupport"],
  enrollment: ["watchEnrollmentTutorial", "helpEnrollment", "contactSupport"],
  alerts: ["helpBillingDescriptor", "contactSupport"],
  "card-info": PRESETS.HELP_AND_SUPPORT,
  "top-up": ["helpBalanceBilling", "contactSupport"],
  getting_started: ["watchGettingStartedTutorial", "helpGettingStarted", "contactSupport"]
}
